// actionTypes.js
export const SET_VALUE_Pexpl = "SET_VALUE_Pexpl";
export const SET_TYPE_Pexpl = "SET_TYPE_Pexpl";
export const SET_CURRENT_PAGE_Pexpl = "SET_CURRENT_PAGE_Pexpl";
export const SET_ORDER_Pexpl = "SET_ORDER_Pexpl";
export const SET_SORT_FIELD_Pexpl = "SET_SORT_FIELD_Pexpl";
export const SET_ACTIF_Pexpl = "SET_ACTIF_Pexpl";
